import React from "react";
import OrderDashboardDocuments from "./components/OrderDashboardDocuments";
import OrderDashboardOrientation from "./components/OrderDashboardOrientation";
import OrderDashboardOverview from "./components/OrderDashboardOverview";
import OrderDashboardJobPosting from "./components/OrderDashboardJobPosting";
import OrderDashboardOrderStatus from "./components/OrderDashboardOrderStatus";
import OrderDashboardShortlist from "./components/OrderDashboardShortlist";
import OrderDashboardSettings from "./components/OrderDashboardSettings";
import OrderMainNav from "components/navigations/OrderNavs/OrderMainNav";
import OrderDashboardRecentActivity from "./components/OrderDashboardRecentActivity";
import OrderDashboardHiringTimeline from "./components/OrderDashboardHiringTimeline";
import OrderLayerBlueprint from "components/blueprints/OrderLayerBlueprint";

function OrderDashboardPage() {
  return (
    <div className="bg-gray-100 py-2">
      <OrderMainNav />
      <div className="container mx-auto my-6 flex">
        <section id="left" className="w-1/2 pr-2">
          <OrderDashboardOverview />
          <OrderDashboardOrderStatus />
          <OrderDashboardHiringTimeline />
        </section>
        <section id="right" className="w-1/2 pl-2">
          <OrderDashboardOrientation />
          <OrderDashboardDocuments />
          <OrderDashboardRecentActivity />
          <OrderDashboardJobPosting />
          <OrderDashboardShortlist />
          <OrderDashboardSettings />
        </section>
      </div>
    </div>
  );
}

export default OrderLayerBlueprint(OrderDashboardPage);
